<template>
  <c-container>
    <c-row class="my-3">
      <c-col>
        <h2>Koszyk - Złóż zamówienie online</h2>
      </c-col>
    </c-row>
    <c-row class="my-2">
      <c-col>
        <p class="lead font-xl">Poniżej znajduje się podsumowanie Twojego zamówienia.
          Jeśli chcesz wprowadzić w nim zmiany, wróć do zakładki "Produkty".
          Poniżej podsumowania znajduje się formularz, za pomocą
          którego możesz przekazać zamówienie do nas.</p>
      </c-col>
    </c-row>
    <c-row class="my-3">
      <c-col>
        <h3>Podsumowanie zamówienia</h3>
      </c-col>
    </c-row>
    <c-row class="my-3">
      <c-col>
        <CartList/>
      </c-col>
    </c-row>
    <c-row class="my-3">
      <c-col>
        <h3>Dane do dostawy</h3>
      </c-col>
    </c-row>
    <c-row class="my-3">
      <c-col>
        <CartForm/>
      </c-col>
    </c-row>
  </c-container>
</template>
<script>
import CartList from '@/components/CartList'
import CartForm from '@/components/CartForm'

export default {
  name: 'CartPage',
  components: {CartForm, CartList}
}
</script>